import * as React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import GabiiReportPage from './GabiiReportPage';
import GabiiFeedbackPage from './GabiiFeedbackPage';

interface RouteParams { 
  url: string 
};

function GabiiReport({ match }: RouteComponentProps<RouteParams>) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={GabiiReportPage}
      />
      <Route
        exact
        path={`${match.url}/feedback`}
        component={GabiiFeedbackPage}
      />
    </Switch>
  );
}

export default GabiiReport;
